import React, {useState} from 'react';
import {MyTeamUser} from '../../../types/TypesPage';
import ClientInfoPopup from './ClientInfoPopup/ClientInfoPopup';
import {formatNumber} from '../../../assets/utils/utils';
import {toast} from 'react-toastify';
import {userQualifications} from '../../../assets/utils/translatersFunc';

type Props = {
	user: MyTeamUser;
	index: number;
	showAll: boolean;
	selectedMonth?: string;
};
const MyTeamListElement: React.FC<Props> = ({user, index, showAll, selectedMonth}) => {
	const [clientInfo, setClientInfo] = useState(0);

	const handleClickQflc = (name: string) => {
		toast(name);
	};
	const handleClickUser = () => {
		setClientInfo(user.user_id);
	};
	const statusWord =
		user.status === 'optima'
			? 'К'
			: ['loyalty', 'business', 'manager', 'lider'].includes(user.status)
				? 'БП'
				: '';
	const userQlfc = userQualifications.find((q) => q.value === user.qlfc);
	const rowNumber = index + 1;
	return (
		<div
			className="filter-team__columns"
			style={{display: index > 49 && !showAll ? 'none' : ''}}
		>
			{clientInfo !== 0 && (
				<ClientInfoPopup
					clientInfo={clientInfo}
					setClientInfo={setClientInfo}
					selectedMonth={selectedMonth}
				/>
			)}
			<span className="filter-team__item filter-team__filter-span-1 ">
				<span className="span__wrapper span__wrapper-1">{rowNumber}</span>
			</span>
			<span className="filter-team__item filter-team__line">{user.level}</span>
			<button
				onClick={handleClickUser}
				className={
					'filter-team__item filter-team__name filter-team__name-' + (index + 1)
				}
			>
				{user.name}
			</button>
			<span className="filter-team__item filter-team__id">{user.contract}</span>
			<span className="filter-team__item filter-team__om">{statusWord}</span>
			<span className="filter-team__item filter-team__registration">
				{user.registration_date}
			</span>
			<span
				className="filter-team__item filter-team__qualification"
				title={userQlfc?.name}
			>
				<span
					role={'button'}
					tabIndex={0}
					onClick={() => handleClickQflc(userQlfc?.name ?? '')}
					className="filter-team__item filter-team__qualification__value"
					style={{background: userQlfc?.background}}
				>
					{userQlfc?.value && !['NA', 'LC', 'AD'].includes(userQlfc.value) ? userQlfc.value : ''}
				</span>
			</span>
			<span className="filter-team__item filter-team__oo">
				{Number(user.active_points).toFixed(1)}
			</span>
			<span className="filter-team__item filter-team__mo">
				{formatNumber(user.active_points_tree, true)}
			</span>
			<span className="filter-team__item filter-team__city">
				{user.address}
			</span>
			<a
				href={'tel:' + user.contact}
				className="filter-team__item filter-team__contact"
			>
				{user.contact}
			</a>
		</div>
	);
};

export default MyTeamListElement;
